export default obj => {
  if (
    !obj 
    || !obj.childMarkdownRemark 
    || !obj.childMarkdownRemark.html
  ) {
    return { __html: '' }
  }

  return { __html: obj.childMarkdownRemark.html }
}